module.exports = __webpack_public_path__ + "Roboto-Bold.ecdd509cadbf1ea78b8d.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Bold.eot
// module id = ../../../../../font/roboto/Roboto-Bold.eot
// module chunks = styles